import { getAppRootPath } from '../lib/getAppRootPath';
import { cleanLocalStorage } from '../session/cleanLocalStorage';
import { isLogoutInProgress } from '../session/utils';

const notAlloweRedirectionPathsRegexp = new RegExp(/sso-redirect/g);

export function logoutOnError(): void {
  if (isLogoutInProgress()) {
    return;
  }

  const isAllowedToRedirect = !notAlloweRedirectionPathsRegexp.test(window.location.pathname);

  if (!isAllowedToRedirect) {
    return;
  }

  cleanLocalStorage();

  window.location.href = `${window.location.origin}${getAppRootPath()}/sso-redirect`;
}
